import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
  } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { ru } from 'date-fns/locale'
import { parse, format, isValid } from 'date-fns';
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { debounce } from 'lodash';


export const DateTimeTable = ({
    values,
    setValues,
    ...params
}) => {

    class RuDateFnsUtils extends DateFnsUtils {
        constructor() {
          super({ locale: ru });
        }
      }

    const dateFormat = "dd.MM.yyyy";

    const parsedDate = useMemo(() => parse(params.value, dateFormat, new Date()), [params.value]);
    const [value, setValue] = useState(null);

    useEffect(() => {
        setValue(parsedDate)
    }, [parsedDate])

    const onChange = (newValue) => {
        
        let getRows = JSON.parse(JSON.stringify(values));
        
        const date = new Date(newValue);
        if (getRows.length !== 0 && isValid(date)) {
            let newRows = []
            getRows.map(row => {
                if (row.id === params.id) {
                    let newRow = row
                    const formatDate = format(date, dateFormat);
                    newRow[params.field] = formatDate;
                    newRows.push(newRow)
                } else newRows.push(row)
            })
            setValues(newRows)
        }  
    }

    return(
        <MuiPickersUtilsProvider utils={RuDateFnsUtils}>
            <KeyboardDatePicker
                onBlur={() => onChange(value)}
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                value={value}
                onChange={(newValue) => setValue(newValue)}
                KeyboardButtonProps={{
                    'aria-label': 'change date',
                }}
                onAccept={(newValue) => {
                    // Срабатывает при выборе даты из календаря
                    setValue(newValue);
                    onChange(newValue)
                }}
            />
        </MuiPickersUtilsProvider>

    )
}